import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/components/Layout";
import Callback from "@/components/Callback";
import ManageClient from "@/components/ManageClient";
import GenerateToken from "@/components/GenerateToken";
import AuthService from "@/auth/AuthService";

Vue.use(VueRouter);

function requireAuth(to, from, next) {
  const auth = new AuthService();
  const { login, isAuthenticated } = auth;
  if (!isAuthenticated()) {
    login();
  } else {
    next();
  }
}

const router = new VueRouter({
  mode: "history", // enable history mode
  routes: [
    {
      path: "/home",
      name: "home",
      component: Layout,
      props: true
    },
    {
      path: "/callback",
      name: "callback",
      component: Callback
    },
    {
      path: "/api-clients",
      name: "api-clients",
      component: ManageClient,
      beforeEnter: requireAuth
    },
    {
      path: "/generate-token",
      name: "generate-token",
      component: GenerateToken,
      beforeEnter: requireAuth
    },
    // Fallback route, in case no route is matched
    {
      path: "*",
      redirect: "/home"
    }
  ]
});

export default router;
